/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { gridPaginaDataSource } from '~/pages/Paginas/PaginasServices';
import { Container } from './styles';

function Lista({ moduloNome, loading }) {
  const history = useHistory();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  return (
    <Container>
      <section>
        <div className="sec1">
          <h1>Páginas</h1>
          <p>
            Módulo: <strong>{moduloNome}</strong>
          </p>
        </div>
        <div className="add">
          <Link to="/page/register" className="link">
            <FaPlus />
          </Link>
        </div>
      </section>
      {loading ? (
        <Spinner
          color="dark"
          style={{ height: '3rem', width: '3rem', margin: ' 100px' }}
        />
      ) : (
        <DataGrid
          dataSource={gridPaginaDataSource}
          remoteOperations
          showBorders
          allowColumnReordering
          allowColumnResizing
          columnAutoWidth
          onOptionChanged={handleOptionChange}
        >
          <Editing mode="row" useIcons allowDeleting />
          <Pager
            visible
            showPageSizeSelector
            allowedPageSizes={[10, 15, 30]}
            showInfo
          />
          <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
          <FilterRow
            visible={filterOptions.showFilterRow}
            applyFilter={filterOptions.currentFilter}
          />
          <Column
            dataField="id"
            caption="ID página"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="nome"
            caption="Nome página"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column type="buttons" caption="Ações" width={100}>
            <Button
              hint="Editar"
              visible
              icon="edit"
              onClick={(e) => history.push(`/page/update/${e.row.data.id}`)}
            />
            <Button name="delete" visible hint="Deletar" icon="trash" />
          </Column>
        </DataGrid>
      )}
    </Container>
  );
}

export default Lista;
